import React from 'react';
import {Link} from "react-router-dom";
import {addSavedRoute, removeSavedRoute} from "../../actions";
import {connect} from "react-redux";
import {withTranslation} from 'react-i18next';
import {compose} from 'redux';
import {useAuth} from "../../context/auth-context";
import {useUser} from "../../hooks/useUser";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import AlertUnlockComponent from "../AlertUnlockComponent";
import Constants from "../../config/constants";
import {getErrorsFromResponse, getTypeFromListItem} from "../../utils/helpers";
import FabRoute from "../FabRoute";
import WarningComponent from "../WarningComponent";
import TooltipComponent from "../TooltipComponent";
import {Alert, Box, ClickAwayListener, Grid, Grow, MenuItem, MenuList, Popper, Typography} from "@mui/material";
import RegionRoute from "../RegionRoute";
import {MuiButton} from "../MuiButton";
import OpenCloseWysiwigContent from "../OpenCloseWysiwigContent";
import useSEO from "../../hooks/useSEO";
import {getUrl, PWAUrls, PWAUrlsParams, replaceUrlParams} from "../../config/urls";
import {format} from "date-fns";
import GlobalFlashMessages from "../User/FlashMessages/FlashMessages";
import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";

const VoieSwitchComponent = ({t, i18n, route}) => {
    const [open, setOpen] = React.useState(false);
    const anchorRef = React.useRef(null);

    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen);
    };

    const handleClose = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }

        setOpen(false);
    };

    function handleListKeyDown(event) {
        if (event.key === 'Tab') {
            event.preventDefault();
            setOpen(false);
        } else if (event.key === 'Escape') {
            setOpen(false);
        }
    }

    return (<>
            <br/>
            <Button
                color="primary"
                variant="contained"
                // style={{paddingLeft:0, textAlign: 'left', fontSize: '15px', fontWeight: 'inherit',}}
                ref={anchorRef}
                id="composition-button"
                aria-controls={open ? 'composition-menu' : undefined}
                aria-expanded={open ? 'true' : undefined}
                aria-haspopup="true"
                onClick={handleToggle}
            >

                <div>
                    <FontAwesomeIcon icon="fas fa-external-link-alt" /> {t('MultipitchSwitch.button.cta', {'count':route.routesFromFace.length})}
                </div>

            </Button>
            <Popper
                open={open}
                anchorEl={anchorRef.current}
                role={undefined}
                placement="bottom-start"
                transition
                disablePortal
            >
                {({ TransitionProps, placement }) => (
                    <Grow
                        {...TransitionProps}
                        style={{
                            transformOrigin:
                                placement === 'bottom-start' ? 'left top' : 'left bottom',
                        }}
                    >
                        <Paper>
                            <ClickAwayListener onClickAway={handleClose}>
                                <MenuList
                                    autoFocusItem={open}
                                    id="composition-menu"
                                    aria-labelledby="composition-button"
                                    onKeyDown={handleListKeyDown}

                                >
                                    {route.routesFromFace.map((routeFromFace) => {
                                        return (<MenuItem selected={window.location.pathname.includes(routeFromFace.slug)}
                                                          component={Link} to={window.location.pathname.replace(route.slug, routeFromFace.slug)}
                                                          key={routeFromFace.id}>
                                            &nbsp;{routeFromFace.label}
                                        </MenuItem>);
                                    })}

                                </MenuList>
                            </ClickAwayListener>
                        </Paper>
                    </Grow>
                )}
            </Popper>
        </>

    );
}

export default
compose(
    withTranslation(),
)(VoieSwitchComponent);